/* =========================================================
   BROKEN PLANET SKIN — static product page gallery
   - Page does not scroll (desktop). Wheel anywhere slowly
     scrolls the BIG image column through the stacked photos
     (continuous, you can rest between photos).
   - Thumbnail strip is a static indicator; click jumps the
     big view to that photo.
   ========================================================= */
(function () {
  function init() {
    var gallery = document.querySelector('.bp-skin media-gallery');
    if (!gallery || gallery.dataset.bpBound === '1') return;

    var viewer = gallery.querySelector('[id^="Slider-Gallery"]'); // ul.product__media-list (the scroller)
    var items = Array.prototype.slice.call(
      gallery.querySelectorAll('.product__media-list .product__media-item')
    );
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('[id^="Slider-Thumbnails"] .thumbnail-list__item button')
    );
    if (!viewer || items.length < 2) return;
    gallery.dataset.bpBound = '1';

    var desktop = window.matchMedia('(min-width: 990px)');

    function activeIndex() {
      var rect = viewer.getBoundingClientRect();
      var cy = rect.top + rect.height / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var d = Math.abs((r.top + r.height / 2) - cy);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    var last = -1;
    function highlight() {
      var i = activeIndex();
      if (i === last) return;
      last = i;
      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].setAttribute('aria-current', j === i ? 'true' : 'false');
      }
      var item = thumbs[i] && thumbs[i].closest('.thumbnail-list__item');
      if (item && item.scrollIntoView) item.scrollIntoView({ block: 'nearest' });
    }

    var raf = 0;
    viewer.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; highlight(); });
    });

    // Wheel anywhere -> scroll the big image column; block page scroll (desktop)
    window.addEventListener('wheel', function (e) {
      if (!desktop.matches) return;
      // allow native scroll inside the open size-guide window
      if (e.target.closest && e.target.closest('.product__accordion[open]')) return;
      e.preventDefault();
      viewer.scrollTop += e.deltaY;
    }, { passive: false });

    // Thumbnail click -> jump big view to that photo
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (items[i]) items[i].scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, true);
    });

    // Arrows nudge the big view
    var up = gallery.querySelector('.thumbnail-slider .slider-button--prev');
    var down = gallery.querySelector('.thumbnail-slider .slider-button--next');
    if (up) up.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      viewer.scrollBy({ top: -viewer.clientHeight * 0.6, behavior: 'smooth' });
    }, true);
    if (down) down.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      viewer.scrollBy({ top: viewer.clientHeight * 0.6, behavior: 'smooth' });
    }, true);

    function applyNoScroll() {
      var root = document.documentElement;
      if (desktop.matches) root.classList.add('bp-no-scroll');
      else root.classList.remove('bp-no-scroll');
    }
    applyNoScroll();
    if (desktop.addEventListener) desktop.addEventListener('change', applyNoScroll);

    highlight();
  }

  // Size guide -> full-screen overlay with an explicit close control
  // The overlay is position:fixed, but Dawn's reveal-on-scroll puts a transform on
  // .product__info-wrapper, and a transformed ancestor makes fixed behave like
  // absolute — which is why on desktop the panel (and its back link) ended up
  // outside the viewport with no visible way out. While open we portal the element
  // to <body>, where nothing can trap it, and put it back on close.
  var sgState = { acc: null, slot: null, open: false };

  function sgClose() {
    var acc = sgState.acc;
    if (!acc || !sgState.open) return;
    var details = acc.querySelector('details');
    if (details) details.open = false;
    acc.classList.remove('bp-sizeguide-open');
    document.documentElement.classList.remove('bp-sg-open');
    if (sgState.slot && sgState.slot.parentNode) {
      sgState.slot.parentNode.insertBefore(acc, sgState.slot);
      sgState.slot.parentNode.removeChild(sgState.slot);
    }
    sgState.slot = null;
    sgState.open = false;
  }

  function sgAddCloseButton(acc) {
    if (acc.querySelector('.bp-sg-close')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bp-sg-close';
    btn.setAttribute('aria-label', 'Zavřít');
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      sgClose();
    });
    acc.appendChild(btn);
  }

  function sgOpen(acc) {
    if (!acc || sgState.open) return;
    var details = acc.querySelector('details');
    if (details) details.open = true;
    var slot = document.createComment('bp-sizeguide-slot');
    if (acc.parentNode) acc.parentNode.insertBefore(slot, acc);
    sgState.slot = slot;
    document.body.appendChild(acc);
    acc.classList.add('bp-sizeguide-open');
    document.documentElement.classList.add('bp-sg-open');
    sgState.acc = acc;
    sgState.open = true;
    sgAddCloseButton(acc);
    window.scrollTo(0, 0);
  }

  function bindSizeGuideEsc() {
    if (document.documentElement.dataset.bpSgEsc === '1') return;
    document.documentElement.dataset.bpSgEsc = '1';
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) sgClose();
    });
  }

  function bindSizeGuide() {
    var acc = document.querySelector('.bp-skin .product__accordion');
    if (!acc || acc.dataset.bpSg === '1') return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (!details || !summary) return;
    acc.dataset.bpSg = '1';
    sgState.acc = acc;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (sgState.open) sgClose();
      else sgOpen(acc);
    });
    // clicking the dark area outside the panel closes it as well
    acc.addEventListener('click', function (e) {
      if (!sgState.open) return;
      var d = acc.querySelector('details');
      if (d && !d.contains(e.target)) sgClose();
    });
  }

  // Inject a "SIZE GUIDE" trigger to the right of the VELIKOST label
  function injectSizeGuideLink() {
    var legend = document.querySelector('.bp-skin .product-form__input--pill legend.form__label');
    if (!legend || legend.querySelector('.bp-size-guide-link')) return;
    var acc = document.querySelector('.bp-skin .product__accordion');
    if (!acc) return;
    var details = acc.querySelector('details');
    if (!details) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bp-size-guide-link';
    btn.textContent = 'SIZE GUIDE';
    btn.addEventListener('click', function () { sgOpen(acc); });
    legend.appendChild(btn);
  }

  // Re-inject after Dawn re-renders <variant-selects> on variant change
  function observeVariantRerender() {
    var host = document.querySelector('.bp-skin');
    if (!host || host.dataset.bpSgObs === '1') return;
    host.dataset.bpSgObs = '1';
    var mo = new MutationObserver(function () { injectSizeGuideLink(); syncCtaWidth(); });
    mo.observe(host, { childList: true, subtree: true });
  }

  // Mobile gallery: build dots indicator synced to the horizontal slider
  function bindMobileGallery() {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    var gallery = document.querySelector('.bp-skin media-gallery');
    if (!gallery || gallery.dataset.bpDots === '1') return;
    var list = gallery.querySelector('.product__media-list');
    var items = list ? Array.prototype.slice.call(list.querySelectorAll('.product__media-item')) : [];
    if (!list || items.length < 2) return;
    gallery.dataset.bpDots = '1';

    var dots = document.createElement('div');
    dots.className = 'bp-dots';
    items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Foto ' + (i + 1));
      if (i === 0) b.className = 'is-active';
      b.addEventListener('click', function () {
        it.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    list.parentNode.insertBefore(dots, list.nextSibling);

    var dotEls = Array.prototype.slice.call(dots.children);
    var raf = 0;
    function update() {
      var center = list.scrollLeft + list.clientWidth / 2;
      var active = 0, bestD = Infinity;
      for (var i = 0; i < items.length; i++) {
        var c = items[i].offsetLeft + items[i].clientWidth / 2;
        var d = Math.abs(c - center);
        if (d < bestD) { bestD = d; active = i; }
      }
      for (var j = 0; j < dotEls.length; j++) {
        dotEls[j].classList.toggle('is-active', j === active);
      }
    }
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    });
    update();
  }

  // Desktop: make the add-to-cart button exactly as wide as the size row.
  // The pills are fixed-size (50px + 10px gap) but the number of sizes differs
  // per product, so the row is measured rather than hard-coded. Width only
  // changes on resize or a variant re-render — never on scroll.
  function syncCtaWidth() {
    var btn = document.querySelector('.bp-skin .product-form__submit');
    if (!btn) return;
    if (!window.matchMedia('(min-width: 990px)').matches) {
      btn.style.removeProperty('width');
      return;
    }
    var labels = document.querySelectorAll('.bp-skin .product-form__input--pill label');
    if (!labels.length) return;
    var left = Infinity, right = -Infinity;
    for (var i = 0; i < labels.length; i++) {
      var r = labels[i].getBoundingClientRect();
      if (!r.width) continue;
      if (r.left < left) left = r.left;
      if (r.right > right) right = r.right;
    }
    var w = right - left;
    if (w > 0 && isFinite(w)) btn.style.setProperty('width', Math.round(w) + 'px', 'important');
  }

  function bindCtaWidth() {
    if (document.documentElement.dataset.bpCtaW === '1') return;
    document.documentElement.dataset.bpCtaW = '1';
    var t = 0;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(syncCtaWidth, 120);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncCtaWidth);
  }

  function boot() { init(); bindSizeGuide(); bindSizeGuideEsc(); injectSizeGuideLink(); observeVariantRerender(); bindMobileGallery(); syncCtaWidth(); bindCtaWidth(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () {
    var g = document.querySelector('.bp-skin media-gallery');
    if (g) g.dataset.bpBound = '';
    boot();
  });
})();
